import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {RepositoryMilestoneIndexPageQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryMilestoneIndexPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneIndexPageQuery'

import {repoRouteBuilder} from '../config/repo-route-builder'

export type MilestoneIndexPayload = RepositoryDataResponse<RepositoryMilestoneIndexPageQueryQuery>

export function buildMilestoneIndexRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('milestonesRoute', {
    path: '/:owner/:repo/milestones',
    queries: [
      mainQuery<MilestoneIndexPayload>({
        queryDeps: ({pathname, searchParams}) => {
          const sort = searchParams.get('sort')
          const direction = searchParams.get('direction')
          return {
            pathname,
            searchParams: {
              queryId: RepositoryMilestoneIndexPageQuery,
              state: searchParams.get('state') || 'open',
              page: searchParams.get('page') || '1',
              ...(sort && direction ? {sort, direction} : {}),
            },
          }
        },
      }),
    ],
  })
}

export const milestoneIndexRoute = buildMilestoneIndexRoute(repoRouteBuilder)
